import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CommentOutlinedSvg from "@ant-design/icons-svg/es/asn/CommentOutlined";
import AntdIcon from "../components/AntdIcon";
var CommentOutlined = function CommentOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CommentOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CommentOutlined.displayName = 'CommentOutlined';
}
export default /*#__PURE__*/React.forwardRef(CommentOutlined);